module.exports = __webpack_public_path__ + "img/logo3Dark.59d36674.png";